import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API } from '../../ApiNames';


export const fetchDataSuccess = (remove: any) => ({
    type: 'FETCH_Remove_SUCCESS',
    payload: remove,
});
export const fetchApproveSuccess = (approvedata: any) => ({
    type: 'FETCH_Approve_SUCCESS',
    payload: approvedata,
});
export const fetchInactiveSuccess = (inactive: any) => ({
    type: 'FETCH_Inactive_SUCCESS',
    payload: inactive,
});





export const removeData = (DoctorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:2,doctorid:DoctorID};
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const ApproveData = (DoctorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:7,doctorid:DoctorID};
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchApproveSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const Inactivedata = (DoctorID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:8,doctorid:DoctorID};
            const apiname = Admin_API.Doc_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchInactiveSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};


